import { render, staticRenderFns } from "./GridLabel.vue?vue&type=template&id=51fe8d8d&scoped=true&"
import script from "./GridLabel.vue?vue&type=script&lang=js&"
export * from "./GridLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe8d8d",
  null
  
)

export default component.exports